import React from "react";
import "./aboutSection.css";
import { motion } from "framer-motion";
import MusicPlayer from "../../components/musicPlayer/MusicPlayer";

import etnaLogo from "../../img/etna.png";
import meIMG from "../../img/me.JPG";

import freeLogo from "../../img/free.svg";
import jcbLogo from "../../img/jcb.png";

import dockerLogo from "../../img/docker.svg";
import figmaLogo from "../../img/figma.svg";
import githubLogo from "../../img/github_dark.svg";
import jsLogo from "../../img/javascript.svg";
import nestLogo from "../../img/nestjs.svg";
import nextLogo from "../../img/nextjs_icon_dark.svg";
import reactLogo from "../../img/react_dark.svg";
import tsLogo from "../../img/typescript.svg";
import linkedinLogo from "../../img/linkedin.svg";
import kotlinLogo from "../../img/kotlin.svg";

const stackIcons = [
  { name: "React", img: reactLogo },
  { name: "Next.js", img: nextLogo },
  { name: "JavaScript", img: jsLogo },
  { name: "TypeScript", img: tsLogo },
  { name: "Kotlin", img: kotlinLogo },
  { name: "NestJS", img: nestLogo },
  { name: "Docker", img: dockerLogo },
  { name: "Figma", img: figmaLogo },
];

const socialLinks = [
  { name: "GitHub", img: githubLogo, url: "https://github.com/JustKIKS" },
  {
    name: "LinkedIn",
    img: linkedinLogo,
    url: "https://www.linkedin.com/in/luka-brouard-026584289/",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.08, ease: [0.33, 1, 0.68, 1] },
  }),
};

const AboutSection = () => {
  return (
    <section className="about" id="about">
      <div style={{ overflow: "hidden", marginBottom: "56px" }}>
        <motion.h1
          className="aboutTitle"
          initial={{ y: "100%" }}
          whileInView={{ y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.33, 1, 0.68, 1] }}
          style={{ marginBottom: 0 }}
        >
          Who am I
        </motion.h1>
      </div>

      <div className="bentoGrid">
        {/* A — Grande photo verticale */}
        <motion.div
          className="bento bento--photo"
          custom={0}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <img src={meIMG} alt="Luka Brouard" className="bento__photo" />
          <div className="bento__photo-overlay">
            <span className="bento__available">
              <span className="greenDot" />
              Open to work
            </span>
          </div>
        </motion.div>

        {/* B — Nom + rôle + entreprises */}
        <motion.div
          className="bento bento--name"
          custom={1}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p
            className="bento__label"
            style={{ textTransform: "none", fontSize: "14px" }}
          >
            Hi there 👋
          </p>
          <h2 className="bento__name">
            I'm Luka,
            <span className="bento__subtitle">
              an Aspiring Full-Stack Developer.
            </span>
          </h2>

          {/* Section "Previously at" - Prend l'espace vide du milieu */}
          <div className="bento__companies">
            <span className="bento__companies-label">Previously at</span>
            <div className="bento__companies-logos">
              <img
                src={freeLogo}
                alt="Free"
                className="companyIcon companyIcon--free"
              />
              <img
                src={jcbLogo}
                alt="Je Croque Bio"
                className="companyIcon companyIcon--jcb"
              />
            </div>
          </div>

          <div className="bento__tags">
            <span className="bento__tag">FR (Native)</span>
            <span className="bento__tag">EN (B2)</span>
            <span className="bento__tag">📍 Paris</span>
          </div>
        </motion.div>

        {/* C — ETNA + timeline */}
        <motion.div
          className="bento bento--etna"
          custom={2}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="bento__etna-top">
            <span className="greenDot" />
            <span className="bento__label">Currently training at</span>
          </div>
          <img src={etnaLogo} alt="ETNA" className="bento__etna-logo" />
          <div className="timeline">
            {[
              { year: "2026", text: "2nd Year - Full-Stack", active: true },
              { year: "2028", text: "Bachelor" },
              { year: "2030", text: "Master" },
            ].map(({ year, text, active }) => (
              <div
                className={`timelineItem${active ? " active" : ""}`}
                key={year}
              >
                <span className="timelineYear">{year}</span>
                <div className="timelineDotWrapper">
                  <span className="timelineDot" />
                  {year !== "2030" && <span className="timelineLine" />}
                </div>
                <span className="timelineText">{text}</span>
              </div>
            ))}
          </div>
        </motion.div>

        {/* D — Stack */}
        <motion.div
          className="bento bento--stack"
          custom={3}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="bento__label">Stack & Tools</p>
          <div className="stackGrid">
            {stackIcons.map((tech, i) => (
              <div className="stackIconWrapper" key={i} title={tech.name}>
                <img src={tech.img} alt={tech.name} className="stackIcon" />
              </div>
            ))}
          </div>
        </motion.div>

        {/* E — Social + Ligne décorative */}
        <motion.div
          className="bento bento--social"
          custom={4}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p className="bento__label" style={{ margin: 0 }}>
            Reach out
          </p>

          <div className="bento__social-divider"></div>

          <div className="bento__social-links">
            {socialLinks.map((s, i) => (
              <a
                href={s.url}
                target="_blank"
                rel="noreferrer"
                className="socialBtn"
                key={i}
              >
                <img src={s.img} alt={s.name} className="socialIcon" />
              </a>
            ))}
          </div>
        </motion.div>

        {/* F — Music Player (FLIGHT - Produced By Me) */}
        <motion.div
          className="bento bento--spotify"
          custom={5}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <MusicPlayer />
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
